import { Tooltip } from "antd";
import { SvgInfo } from "components/svg";
import { CHART_BARCHART_OPTIONS, CHART_COLOR_3, CHART_COLOR_3b } from "configApp";
import { useCallback, useEffect, useState } from "react";
import { useAppSelector } from "store/hooks";
import useTranslation from "utils/hooks/useTranslation";

interface ProductModalContentProps {
    data?: any
}
const ProductModalContent7: React.FC<ProductModalContentProps> = ({ data }) => {
    const { t, tHtml } = useTranslation();
    const product = data; // NOSONAR
    const [, setWindowSize] = useState(null); // NOSONAR
    const projectStore = useAppSelector((state) => state.project);

    const barChartOptions = {
        ...CHART_BARCHART_OPTIONS,
        ...{
            title: t('PIECHART_RAF_ANNUAL_CONFORT_TITLE'),
            isStacked: true,
            seriesType: 'bars',
            //series: {3: {type: 'line'}, 4: {type: 'line', lineDashStyle: [4, 4]}},
            interpolateNulls: true,

            // Gestion bar horizontal de référence:
            // https://stackoverflow.com/questions/23535668/drawing-visual-lines-in-google-charts
            hAxis: {
                textPosition: 'none',
                format: 'Q#',
                ticks: [1],
                viewWindow: {
                    min: 0,
                    max: 3
                }
            },
            vAxis: {
                title: t('PIECHART_RAF_YAXIS'),
                titleTextStyle: { italic: false },
            },
            annotations: {
                textStyle: {
                    color: 'black',
                    fontSize: 11,
                },
                alwaysOutside: false
            }
        }
    };

    const handleResize = useCallback(() => {
         // @ts-ignore
        delete barChartOptions.animation;
        setWindowSize(window.innerWidth as any);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        window.addEventListener("resize", handleResize);

        // Fix a bug on smartphone to adapt first chart to screen size
        setTimeout(() => {
            setWindowSize(window.innerWidth as any);
        }, 100)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        return () => {
            window.removeEventListener("resize", handleResize);
        }
        // eslint-disable-next-line no-use-before-define
    }, [handleResize]);


    const drawChartCoolMode = (conso: any) => {
        const Tre2020 = 26;
        const consigne = projectStore.project.forms.coolModeStep.form.temperature;
        const showZone2 = projectStore.project.forms.coolModeStep.form.temperature < Tre2020;
        const tempMax = Math.max(consigne, Tre2020);

        const reference = conso.ConfortTX + conso.InteriorTX;

        // Gestion bar horizontal de référence:
        // https://stackoverflow.com/questions/23535668/drawing-visual-lines-in-google-charts
        // VOIR configuration hAxis + les lignes chartData 0 et 3.
        const chartData = [
            ['', `<${consigne}°C`, { role: 'annotation' }, { role: 'tooltip' }, `${consigne}°C-${Tre2020}°C`, { role: 'annotation' }, { role: 'tooltip' }, `>${tempMax}°C`, { role: 'annotation' }, { role: 'tooltip' }, t('PIECHART_RAF_RT2020', { temp: Tre2020 }), { role: 'tooltip' }, t('PIECHART_RAF_TEMP_SET', { temp: consigne }), { role: 'tooltip' }],
            [0, null, null, null, null, null, null, null, null, null, reference * 100, null, conso.ConfortTX * 100, null],
            [1,
                 // @ts-ignore
                conso.ConfortTX * 100, conso.ConfortTX > 0.06 ? (conso.ConfortTX * 100).round(1) + '%' : null, `<${consigne}°C (${(conso.ConfortTX * 100).round(1)}%)`,
                 // @ts-ignore
                conso.InteriorTX * 100, conso.InteriorTX > 0.06 ? (conso.InteriorTX * 100).round(1) + '%' : null, `${consigne}°C-${Tre2020}°C (${(conso.InteriorTX * 100).round(1)}%)`,
                 // @ts-ignore
                conso.DisconfortTX * 100, conso.DisconfortTX > 0.06 ? (conso.DisconfortTX * 100).round(1) + '%' : null, `>${tempMax}°C (${(conso.DisconfortTX * 100).round(1)}%)`,
                 // @ts-ignore
                reference * 100, t('PIECHART_RAF_RT2020', { temp: Tre2020 }) + ` ${parseInt(reference * 100)}%`,
                 // @ts-ignore
                conso.ConfortTX * 100, t('PIECHART_RAF_TEMP_SET', { temp: consigne }) + ` ${parseInt(conso.ConfortTX * 100)}%`],
            [3, null, null, null, null, null, null, null, null, null, reference * 100, null, conso.ConfortTX * 100, null],
        ];

        if (!showZone2) {
            chartData.forEach(function (cd) {
                cd.splice(10, 2);
                cd.splice(4, 3);
            })
        }

        // @ts-ignore
        const data = new window.google.visualization.arrayToDataTable(chartData);
        // @ts-ignore
        const formatter = new window.google.visualization.NumberFormat({
            fractionDigits: 0,
            suffix: '%'
        });
        formatter.format(data, 1);

        const chartDiv = document.getElementById('chartCoolMode');
        // @ts-ignore
        const chart = new window.google.visualization.ComboChart(chartDiv);

        chart.draw(data, {
            ...barChartOptions,
            ...{
                colors: showZone2 ? CHART_COLOR_3 : CHART_COLOR_3b,
                series: showZone2 ? { 3: { type: 'line' }, 4: { type: 'line', lineDashStyle: [4, 4] } } : { 2: { type: 'line', lineDashStyle: [4, 4] } },
            }
        });
    };

    // window.google.charts.load('current', {packages: ['corechart'], language: UIStore.lang});
    // window.google.charts.setOnLoadCallback(() => drawChartCoolMode(product.E5));

    useEffect(() => {
        drawChartCoolMode(product.E5); // NOSONAR
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <group
                //data-width="auto"
                data-gap="30"
                data-text-size="medium"
                data-space-vertical="30"
                data-space-horizontal="50"
                data-direction="column"
                data-justify="start"

            >


                <group data-height="450"
                    data-background="grey-color-light"

                >
                    <group id="chartCoolMode" />
                </group>
                <group>
                    <group
                        data-fit="1"
                        data-max-length="40"
                        data-align="start"
                    //data-length="forcefit"
                    >
                        <Tooltip
                            arrow={false}
                            //color="var(--accent-dark)"
                            color="var(--white)"
                            //space={false}
                            title={
                                <group
                                    data-direction="column"
                                    data-gap="10"
                                    data-space="10"
                                    data-max-length="500"
                                >
                                    <text data-color="black" data-line="1.5">
                                        {tHtml("HELP_PIE_CHART")}
                                    </text>
                                </group>
                            }
                        >
                            <icon data-svg-size="24" data-svg-color="main" data-cursor="pointer" >
                                <SvgInfo />
                            </icon>
                        </Tooltip>
                    </group>
                    <group
                        data-fit="1"
                    //data-length="forcefit"
                    >
                        {tHtml('PIECHART_RAF_TEXT', {
                             // @ts-ignore
                            jour1: data.StartDay, // NOSONAR
                            mois1: data.StartMonth, // NOSONAR
                            jour2: data.EndDay, // NOSONAR
                            mois2: data.EndMonth, // NOSONAR
                            jours: data.NbDays // NOSONAR
                        })}
                    </group>
                </group>

            </group>
        </>
    )
}

export default ProductModalContent7;